import React, { useContext, useState } from "react";
import { MixitContext } from "../contexts/MixitContext";
import { DataContext } from "../contexts/DataContext";

// check for prefiltered tab and set if so
let urlPaths = document.querySelector("#prefilter_setting");
urlPaths == null
  ? (urlPaths = "All Articles")
  : (urlPaths = urlPaths.textContent);

const TabsMixit = () => {
  const { mixitBuildData, setNumberOfMixitArticles } = useContext(MixitContext);
  const { setMixitSetting, setArticleListPosition, sitePaths, config } =
    useContext(DataContext);

  const [activeButton, setActiveButton] = useState(urlPaths);

  const matchedCategory = mixitBuildData
    .filter((mixit) =>
      sitePaths
        .map((path) => path.toLowerCase())
        .includes(mixit.name.toLowerCase().replace(/\s+/g, "-"))
    )
    .reverse()[0];

  function mixitSelectHandler(e) {
    e.preventDefault();
    const mixitSelected =
      e.target.id === "All Articles"
        ? ""
        : "&filters[Tags][Category]=" + e.target.id.replace(/\s/g, "%20");
    setMixitSetting(mixitSelected);
    setActiveButton(e.target.id);
    // console.log('count: ' +e.target.value);
    setNumberOfMixitArticles(e.target.value); // set number of articles based on tab's selected count
    setArticleListPosition(1); // resets list position for pagination back to 1 if new tab category selected
  }

  return (
    <>
      {!mixitBuildData.find(
        (mixit) =>
          (matchedCategory !== undefined &&
            mixit.name.toLowerCase() ===
              matchedCategory.name.toLowerCase()) ||
          (sitePaths.map((path) => path.toLowerCase()).includes("news") &&
            config.siteName === "Sesame.co.uk")
      ) ? (
        <div>
          <div className="mixit_tabs">
            {mixitBuildData.map((btn) => (
              <button
                key={btn.id}
                id={btn.name}
                onClick={mixitSelectHandler}
                value={btn.count}
                className={
                  btn.name === activeButton
                    ? "btn btn-secondary"
                    : "btn btn-primary"
                }
              >
                {btn.name}
              </button>
            ))}
            <br />
          </div>
        </div>
      ) : null}
    </>
  );
};

export default TabsMixit;
